<template>
    <div>
        <v-btn v-if="showBtn" icon @click="onClick">
            <v-icon color="secondary">mdi-plus</v-icon>
        </v-btn>
        <create-prescription-dialog v-if="libraryTab === 'prescriptions'" ref="createPrescriptionDialog"
            :coachId="coachId" />
        <create-circuit-dialog v-if="libraryTab === 'blocks'" ref="createCircuitDialog"
            :coachId="coachId" />
    </div>
</template>

<script>
import { mapState } from 'vuex';
import CreateCircuitDialog from '../../coach/routines/CreateCircuitDialog.vue';
import CreatePrescriptionDialog from '../../coach/routines/CreatePrescriptionDialog.vue';


export default {
    components: { CreatePrescriptionDialog, CreateCircuitDialog },
    computed: {
        ...mapState(['libraryTab']),
        showBtn(vm = this) {
            return ['routines', 'prescriptions', 'blocks'].includes(vm.libraryTab)
        },
        coachId(vm = this) {
            return vm.currentUser.uid
        }
    },
    methods: {
        onClick() {
            const vm = this
            if (vm.libraryTab === 'routines') return vm.$router.push({ name: `${vm.accountType}.routines.create` })
            if (vm.libraryTab === 'prescriptions') return vm.showCreatePrescriptionDialog()
            if (vm.libraryTab === 'blocks') return vm.showCreateCircuitDialog()
        },
        showCreatePrescriptionDialog() {
            const vm = this;
            vm.$refs.createPrescriptionDialog.show()
        },
        showCreateCircuitDialog() {
            const vm = this;
            vm.$refs.createCircuitDialog.show()
        }
    },
}
</script>